module.exports = __webpack_public_path__ + "static/scale-model-of-denver-millennium-bridge-in-lakewood-colorado-ce5dbe6101088ec47fc7db60a1debe64.png";